import { render, staticRenderFns } from "./CommonArticleList.vue?vue&type=template&id=60260bb6&"
import script from "./CommonArticleList.vue?vue&type=script&lang=js&"
export * from "./CommonArticleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/daum/program/jenkins/workspace/cafe-web/cafe-web-production/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60260bb6')) {
      api.createRecord('60260bb6', component.options)
    } else {
      api.reload('60260bb6', component.options)
    }
    module.hot.accept("./CommonArticleList.vue?vue&type=template&id=60260bb6&", function () {
      api.rerender('60260bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/bbs-list/bottom/components/CommonArticleList.vue"
export default component.exports